import { z } from 'zod'
import { backtestPresetSettingsSchema } from './backtest-preset.schema'
import { backtestInstrumentSchema } from './backtest-config.schema'

// marker so a paste can verify the clipboard text is an fp3 settings envelope
export const SETTINGS_CLIPBOARD_KIND = 'fp3.backtest.settings' as const

// a per-instrument entry in a config envelope: identified by ticker because the
// T-Bank UID is environment-specific and is resolved on paste. carries any
// subset of the per-instrument strategy overrides (same fields as a backtest
// instrument row, minus the resolved instrumentUid).
export const clipboardInstrumentSchema = backtestInstrumentSchema
  .omit({ instrumentUid: true })
  .extend({ ticker: z.string().min(1) })
export type ClipboardInstrumentDto = z.infer<typeof clipboardInstrumentSchema>

// v1: strategy settings only (legacy, still produced by copySettings).
const clipboardV1Schema = z.object({
  kind: z.literal(SETTINGS_CLIPBOARD_KIND),
  version: z.literal(1),
  settings: backtestPresetSettingsSchema,
})
// v2: adds an optional ticker-keyed instrument basket so a whole config
// (settings + basket) can be pasted in one action.
const clipboardV2Schema = z.object({
  kind: z.literal(SETTINGS_CLIPBOARD_KIND),
  version: z.literal(2),
  settings: backtestPresetSettingsSchema,
  instruments: z.array(clipboardInstrumentSchema).max(50).optional(),
})

// versioned wrapper around the portable config unit. add a new member + bump
// the literal on breaking changes; older members keep parsing.
export const settingsClipboardSchema = z.discriminatedUnion('version', [
  clipboardV1Schema,
  clipboardV2Schema,
])

export type SettingsClipboardDto = z.infer<typeof settingsClipboardSchema>
